import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect } from "react";
import { FcHighPriority, FcPlus } from "react-icons/fc";
import { useNavigate } from "react-router-dom";

export const SubmenuParentingPage = () => {
  const navigate = useNavigate();
  const { setHeader } = useThemeStore((state) => state);

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Kepengasuhan",
    });
  }, [setHeader]);
  return (
    <div className="tw-p-4 tw-pb-0 menu">
      <div className="card-body-grid">
        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.ACHIEVEMENT_PAGE)}
            className="tw-m-0"
          >
            <FcPlus className="card-icon" style={{ background: "#c4e9c4" }} />
            <div className="tw-mt-0 card-name">Prestasi</div>
          </div>
        </div>

        <div className="card-grid">
          <div
            onClick={() => navigate(linkPage.VIOLATION_PAGE)}
            className="tw-m-0"
          >
            <FcHighPriority
              className="card-icon"
              style={{ background: "#eee" }}
            />
            <div className="tw-mt-0 card-name">Pelanggaran</div>
          </div>
        </div>
      </div>
    </div>
  );
};
